import fetchJSON from '@api/api_helper';

const { type, key } = BF.fx.brandfolder();
const url = () => `/api/v4/${type.toLowerCase()}s/${key}/sections?per=1000`;

export const get = () => (
  fetchJSON(url())
    .then(({ data }) => data)
    .catch(async (response) => { throw (await response.json()); })
);
